<div class="form-group" [ngClass]="{ 'has-error': control.invalid, required: required }">
  <label *ngIf="label" [attr.for]="id">{{ label }}</label>
  <xux-hint [description]="description" container="body" placement="auto"></xux-hint>
  <div [ngClass]="{ 'input-group': addonButton }">
    <input
      [ngStyle]="{
        color: textColorObs | async,
        'background-color': backgroundColorObs | async
      }"
      class="{{ class }}"
      [attr.id]="id"
      [attr.name]="name"
      [attr.type]="type"
      [attr.placeholder]="placeholder"
      [formControl]="control"
      [attr.required]="required ? 'true' : null"
      [attr.disabled]="disabled ? 'true' : null"
      [attr.max]="max"
      [attr.min]="min"
      [attr.readonly]="readonly ? 'true' : null"
      [attr.data-integration-id]="'input'"
    />
    <span
      *ngIf="addonButton"
      class="input-group-addon {{ addonButton.class || '' }}"
      (click)="addonButtonClickActionHandle(addonButton)"
    >
      <i *ngIf="addonButton.glyphicon" class="glyphicon {{ addonButton.glyphicon }}"></i>
      {{ addonButton.caption }}
    </span>
    <span *ngIf="control.status === 'PENDING'">{{ staticTextContent.loading | translate }} ...</span>
  </div>
  <xvi-error-block [control]="control"></xvi-error-block>
</div>
